$('.variantchange').on('change', function() {
  
  var vid = $(this).find(':selected').attr('data-variant-id');
  var vprice = $(this).find(':selected').attr('data-price');
  var sprice = $(this).find(':selected').attr('data-regular-price');
  var viimage = $(this).find(':selected').attr('data-image');
  var pid = $(this).find(':selected').attr('data-product-id');
  var sid = $(this).find(':selected').attr('data-section-id');   
  $('.myprice_'+pid).text(vprice);
  $('.myprice_regular_'+pid).text(sprice);
  $('.myid_'+pid).val(vid);
 // $('.myimage_'+pid).attr("src",viimage);
  //$('.myimage_'+pid).removeAttr('srcset');
});
$(".mycustomformajax").submit(function(e) {
    e.preventDefault(); // Prevent default form submission

    var formdata = $(this).serialize(); // Serialize form data

    // Use Shopify AJAX API to add item to cart
    jQuery.post('/cart/add.js', formdata, function(itemData) {  
        window.refreshCartNew(); // Refresh the cart
        // Optionally, you can display a message or perform other actions here
        $(e.target).find('.button__text').text(' Product added'); 
        setTimeout(function(){ $(e.target).find('.button__text').text(' Add to cart'); }, 2000);
        
    }, 'json')
    .fail(function(xhr, status, error) {       
        console.error(xhr.responseText);
        alert('Failed to add product to cart. Please try again later.');
    });
});
